// extracted by mini-css-extract-plugin
module.exports = {"background":"n_m","gradient":"n_L"};